import AppRoutes from "./AppRoutes.js";
import { ArticleProvider } from "./context/ArticleContext.js";
import { DailyProvider } from '@daily-co/daily-react';

// Replace with your actual Daily room URL
const ROOM_URL = "https://your-domain.daily.co/your-room";

function App() {
  return (
    <DailyProvider url={ROOM_URL}>
      <ArticleProvider>
        <AppRoutes />
      </ArticleProvider>
    </DailyProvider>
  );
}

export default App;
